import Machine from '../../../../../types/api/machine'
import { Zones } from '../../../../../types/api/print-queue-entry'
import {
    materialRequirementsPopulate,
    shipmentAvailabilityPopulate,
    shipmentPeoplePopulate,
} from '../../../../schedules/flexo/constants/shipment-populate'

export const getQueryParams = (machine: Machine) => ({
    filters: {
        zone: { $eq: Zones.Main },
        machine: {
            documentId: {
                $eq: machine.documentId,
            },
        },
    },
    populate: {
        print_job: {
            populate: {
                shipment: {
                    populate: {
                        ...shipmentAvailabilityPopulate,
                        ...shipmentPeoplePopulate,
                        stamp: { populate: ['tube', 'roller', 'image'] },
                        virtualStamp: { populate: ['roller'] },
                        machine: true,
                        additional_machines: true,
                        client: true,
                        shipment_positions: true,
                        materialRequirements: { populate: materialRequirementsPopulate },
                        calculated: true,
                        calculatedOnActual: true,
                        tasks: { fields: ['type'] },
                        honestSignsCodesFile: true,
                    },
                },
                print_job_executors: {
                    populate: {
                        user: true,
                    },
                },
            },
        },
        machine: true,
    },
    sort: ['sort:asc'],
    pagination: { pageSize: 500, page: 1 },
})
